import { SpaMsgTempBookingSnapshot } from "@/types/booking/checkout";
import { useMemo } from "react";

export type TourActBookingKeyPayload = {
  activityId: string;
  contextKey: string;
  key: string;
};

export function isSpaMsgTempBookingSnapshot(
  raw: unknown,
): raw is SpaMsgTempBookingSnapshot {
  if (!raw || typeof raw !== "object") {
    console.warn("[isSpaMsgTempBookingSnapshot] not an object", raw);
    return false;
  }

  const snapshot = raw as Record<string, unknown>;

  const checks = {
    svcType: snapshot.svcType === "spa_msg",
    bookingSessionId: typeof snapshot.bookingSessionId === "number",
    remainingTimeInSecond: typeof snapshot.remainingTimeInSecond === "number",
    isExpired: typeof snapshot.isExpired === "boolean",
    booking: typeof snapshot.booking === "object" && snapshot.booking !== null,
    spa_msg: typeof snapshot.spa_msg === "object" && snapshot.spa_msg !== null,
    services: Array.isArray(snapshot.services),
    coupon: snapshot.coupon === null || typeof snapshot.coupon === "object",
  };

  const passed = Object.values(checks).every(Boolean);

  if (!passed) {
    console.warn("[isSpaMsgTempBookingSnapshot] shape mismatch", {
      checks,
      raw: snapshot,
    });
  }

  return passed;
}